import React from 'react';
import { useDispatch } from 'react-redux';

import { useTranslation } from '@common/hooks/translation';
import { CashoutMoney, EndVerificationSession } from '@app/dev/actions/terminal';
import { useBalance } from '@app/dev/terminal/hooks/balance';

const VerificationLogOut = ({ closePopup }) => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const terminalBalance = useBalance();

  const logout = () => {
    dispatch(EndVerificationSession());
    closePopup();
    if (terminalBalance) dispatch(CashoutMoney(null));
  };

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Do you want to end the session')}</h3>
      <div className="popup-main-content">
        <i className="global-icon icon-logout popup-main-icon" />
        <p className="text-center">{t('Your remaining balance will be issued as a ticket. Please present this ticket at the cashier to receive your cash')}</p>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={closePopup}
          className="popup-cancel-button"
        >
          {t('Cancel')}
        </button>
        <button
          type="button"
          onClick={logout}
          className="popup-confirm-button"
        >
          {t('Log out')}
        </button>
      </div>
    </div>
  );
};

export default VerificationLogOut;
